<template>
  <div>
    <template v-if="component.contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !lock">

          <mimic-amp-sidebar side="top-right">
            <nav class="sidebar-nav">
              <h2 class="sidebar-nav-h2">
                <a class="sidebar-nav-a">
                  <mimic-amp-img :image="logo" v-if="logo.src"></mimic-amp-img>
                  <div v-if="!logo.src" style="color:red">Settingsでロゴを設定して選択してください。</div>
                </a>
              </h2>
              <ul class="nav-list">
                <template v-for="(page, index) in publishedPages">
                  <li v-if="page.parent === 0" :key="index" class="nav-item"><a class="nav-item-a">{{ page.title.rendered }}<i class="fa fa-angle-right" aria-hidden="true"></i></a></li>
                </template>
              </ul>
            </nav>
          </mimic-amp-sidebar>

        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'
import MimicAmpImg from '@/components/mimic-amp/MimicAmpImg'
import MimicAmpSidebar from '@/components/mimic-amp/MimicAmpSidebar'

export default {
  name: 'sidebar-standard-1',
  components: {
    'mimic-amp-img': MimicAmpImg,
    'mimic-amp-sidebar': MimicAmpSidebar
  },
  mixins: [ComponentBase],
  computed: {
    logo: function () {
      return this.settings.site.logo
    }
  },
  methods: {
    /**
     * コンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      const html = `
      <amp-sidebar class="sidebar theme-base-bg-color" id="sidebar" layout="nodisplay" side="right">
        <button class="sidebar-button close" on="tap:sidebar.close" role="button" tabindex=1><svg class="sidebar-svg theme-accent-fill-color" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"><path d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5 c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9 c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"/></svg></button>
        <nav class="sidebar-nav">
          <h2 class="sidebar-nav-h2">
            <a class="sidebar-nav-a" href="${this.url}">
              <amp-img width="${this.logo.width}" height="${this.logo.height}" layout="responsive" src="${this.logo.src}" alt="${this.settings.site.owner}ロゴ画像" attribution="${this.settings.site.owner} All Rights Reserved."><p fallback>${this.settings.site.owner}</p>
              </amp-img>
            </a>
          </h2>
          getNavListType1
        </nav>
      </amp-sidebar>

      <button class="sidebar-button open" on="tap:sidebar.toggle" role=button tabindex=0><svg class="sidebar-svg theme-accent-fill-color" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"><path d="M417.4,224H94.6C77.7,224,64,238.3,64,256c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32 C448,238.3,434.3,224,417.4,224z"/><path d="M417.4,96H94.6C77.7,96,64,110.3,64,128c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32 C448,110.3,434.3,96,417.4,96z"/><path d="M417.4,352H94.6C77.7,352,64,366.3,64,384c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32 C448,366.3,434.3,352,417.4,352z"/></svg>
      </button>`
      return html.replace(/>\s+</g, '><').replace(/(\r\n|\n|\r)/gm, '').replace(/^\s+|\s+$/g, '')
    },
    /**
     * コンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = ''
      return {layout, theme}
    }
  }
}
</script>

<style lang="scss" scoped>
.native {
  @import "./SidebarStandard1.scss";
}
.smartphone,
.tablet,
.desktop {
  @import "./SidebarStandard1.s.scss";
  .sidebar {
    &-button {
      position: absolute !important;
    }
  }
}
.tablet,
.desktop {
  @import "./SidebarStandard1.m.scss";
}
.desktop {
  @import "./SidebarStandard1.l.scss";
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/SidebarStandard1/SidebarStandard1.vue